import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import "./portalEventCard.scss";

export type TPortalEventType = "tournament" | "league" | "wedding" | "banquet" | "other";

export type TPortalEventCard = {
  id: number;
  name: string;
  type: TPortalEventType;
  logo_source?: string;
  fallback_logo_source?: string;
  date_label: string;
  onClick?: () => void;
};

export function getPortalEventTypeLabel(type: TPortalEventType, t: (key: string) => string) {
  switch (type) {
    case "league":
      return t("League");
    case "tournament":
      return t("Tournament");
    case "wedding":
      return t("Wedding");
    case "banquet":
      return t("Banquet");
    default:
      return t("Other");
  }
}

export default function PortalEventCard(props: TPortalEventCard) {
  const { t } = useTranslation();
  const logoSource = props.logo_source || props.fallback_logo_source;

  return (
    <div
      className={classNames("portal-event-card", { "portal-event-card-clickable": !!props.onClick })}
      onClick={props.onClick}
      role={props.onClick ? "button" : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      onKeyDown={
        props.onClick
          ? event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                props.onClick?.();
              }
            }
          : undefined
      }
    >
      <div className="portal-event-card-logo-wrap">
        {logoSource ? (
          <img className="portal-event-card-logo" src={logoSource} alt="" />
        ) : (
          <div className="portal-event-card-logo-placeholder" />
        )}
      </div>
      <div className="portal-event-card-name">{props.name}</div>
      <span className={classNames("portal-event-type-badge", `portal-event-type-badge-${props.type}`)}>
        {getPortalEventTypeLabel(props.type, t)}
      </span>
      <div className="portal-event-card-date">{props.date_label}</div>
    </div>
  );
}
